import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import LxcError from "~/core/models/LxcError.class";
import { downloadJsonFile } from "~/core/utils/download.utils";
import { NotificationKey } from "~/core/utils/notifications";
import licenseService from "~/modules/license/services/license.service";

export function useDownloadPlatformIdCard(organizationCode?: number) {
  const isLoading = ref(false);
  const { can } = useAcl();

  async function downloadPlatformIdCard() {
    isLoading.value = true;
    const response = await licenseService.getPlatformIdCard(organizationCode);
    if (LxcError.check(response)) {
      response.notify(NotificationKey.error);
    } else {
      downloadJsonFile(response, "platform-id-card.json");
    }
    isLoading.value = false;
  }

  const canDownloadPlatformIdCard = () => {
    return can(ACLRoles.CAN_READ_LICENSE);
  };

  return {
    isLoading,
    downloadPlatformIdCard,
    canDownloadPlatformIdCard,
  };
}
